import { Phase as CalculationPhase } from '@sequencehq/utils'
import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'

type ApiPhases = DashboardApi20240730.Quotes.Quote['phases']

/**
 * The API may return fields using v99990101 names instead of v20240730.
 * Normalise to the shape expected by the pricing-calculation utilities:
 *  - discounts: `type` → `discountCalculationType`
 *  - seat-based prices: `includedSeats` → `contractedMinimumSeats`
 */
export const adaptPhasesForCalculation = (
  phases: ApiPhases
): Array<CalculationPhase & { id: string }> =>
  phases.map(phase => ({
    ...phase,
    prices: phase.prices.map(price => ({
      ...price,
      structure:
        price.structure.pricingType === 'SEAT_BASED'
          ? {
              ...price.structure,
              contractedMinimumSeats:
                price.structure.contractedMinimumSeats ??
                (
                  price.structure as unknown as {
                    includedSeats: number
                  }
                ).includedSeats ??
                0
            }
          : price.structure
    })),
    discounts: phase.discounts.map(discount => ({
      ...discount,
      discountCalculationType:
        discount.discountCalculationType ??
        (discount as unknown as { type: string }).type
    }))
  }))
